export const DEFAULT_PLOTSIZE = 5;
export const FIELDMAP_MAXRECORD_COUNT = 50000;
export const MANUAL_RANDOMIZED_REP_COLOR = [106, 95, 86, 1];
export const MANUAL_RANDOMIZED_REP_OUTLINE_COLOR = [255, 255, 255, 1];
export const FILLER_OUTLINE_COLOR = [252, 85, 12, 1];
export const FEET_METER_CONSTANT = 0.3048;
export const SNAPPING_ERROR_TOLERANCE = 0.1 * FEET_METER_CONSTANT; // 0.1 feet in meters.
export const HEATMAP_LEGEND_CONTAINER_ID = 'heatMapLegendContainer';
export const UTM_ZONE_DISPLAY_CONTAINER_ID = 'utmZoneDisplayContainer';

const GRID_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'layerid',
    type: 'esriFieldTypeString',
    alias: 'layerid',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'uniqueid',
    type: 'esriFieldTypeString',
    alias: 'uniqueid',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rangerow',
    type: 'esriFieldTypeString',
    alias: 'rangerow',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'rangevalue',
    type: 'esriFieldTypeInteger',
    alias: 'rangevalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'rowvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rowvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'rangeskipper',
    type: 'esriFieldTypeInteger',
    alias: 'rangeskipper',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 1,
  },
  {
    name: 'rowskipper',
    type: 'esriFieldTypeInteger',
    alias: 'rowskipper',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 1,
  },
  {
    name: 'width',
    type: 'esriFieldTypeDouble',
    alias: 'width',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0.0,
  },
  {
    name: 'plotlength',
    type: 'esriFieldTypeDouble',
    alias: 'plotlength',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0.0,
  },
  {
    name: 'isselected',
    type: 'esriFieldTypeInteger',
    alias: 'isselected',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'repstatus',
    type: 'esriFieldTypeString',
    alias: 'repstatus',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'joinkey',
    type: 'esriFieldTypeString',
    alias: 'joinkey',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'angle',
    type: 'esriFieldTypeDouble',
    alias: 'angle',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];

const BLOCK_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'repstatus',
    type: 'esriFieldTypeString',
    alias: 'repstatus',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'id',
    type: 'esriFieldTypeString',
    alias: 'id',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'trialid',
    type: 'esriFieldTypeInteger',
    alias: 'trialid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'repid',
    type: 'esriFieldTypeInteger',
    alias: 'repid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'fdid',
    type: 'esriFieldTypeInteger',
    alias: 'fdid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'rangevalue',
    type: 'esriFieldTypeInteger',
    alias: 'rangevalue',
    nullable: false,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'rowvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rowvalue',
    nullable: false,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'direction',
    type: 'esriFieldTypeString',
    alias: 'direction',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'uniqueid',
    type: 'esriFieldTypeString',
    alias: 'uniqueid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'productname',
    type: 'esriFieldTypeString',
    alias: 'productname',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'entrynumber',
    type: 'esriFieldTypeInteger',
    alias: 'entrynumber',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'crop',
    type: 'esriFieldTypeString',
    alias: 'crop',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'treatmentdata',
    type: 'esriFieldTypeString',
    alias: 'treatmentdata',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'groupnumber',
    type: 'esriFieldTypeInteger',
    alias: 'groupnumber',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: -1,
  },
  {
    name: 'reprandomizationtype',
    type: 'esriFieldTypeString',
    alias: 'reprandomizationtype',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'rcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'gcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'gcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'bcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'bcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'alphavalue',
    type: 'esriFieldTypeDouble',
    alias: 'alphavalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];

const GRIDLABEL_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'uniqueid',
    type: 'esriFieldTypeString',
    alias: 'uniqueid',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rangevalue',
    type: 'esriFieldTypeInteger',
    alias: 'rangevalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'rowvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rowvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'rangerow',
    type: 'esriFieldTypeString',
    alias: 'rangerow',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'layerid',
    type: 'esriFieldTypeString',
    alias: 'layerid',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'angle',
    type: 'esriFieldTypeDouble',
    alias: 'angle',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];

const BLOCKLABEL_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'id',
    type: 'esriFieldTypeString',
    alias: 'id',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'name',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'textvalue',
    type: 'esriFieldTypeString',
    alias: 'textvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'repid',
    type: 'esriFieldTypeInteger',
    alias: 'repid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'angle',
    type: 'esriFieldTypeInteger',
    alias: 'angle',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'groupnumber',
    type: 'esriFieldTypeInteger',
    alias: 'groupnumber',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
];
const REP_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'id',
    type: 'esriFieldTypeString',
    alias: 'id',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'name',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: '',
  },
  {
    name: 'crop',
    type: 'esriFieldTypeString',
    alias: 'crop',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'ishighlighted',
    type: 'esriFieldTypeInteger',
    alias: 'ishighlighted',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'repid',
    type: 'esriFieldTypeInteger',
    alias: 'repid',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'groupnumber',
    type: 'esriFieldTypeInteger',
    alias: 'groupnumber',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
];
const BORDER_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'id',
    type: 'esriFieldTypeString',
    alias: 'id',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'crop',
    type: 'esriFieldTypeString',
    alias: 'crop',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'availableplots',
    type: 'esriFieldTypeInteger',
    alias: 'availableplots',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];
const FILLER_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'crop',
    type: 'esriFieldTypeString',
    alias: 'crop',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rangerow',
    type: 'esriFieldTypeString',
    alias: 'rangerow',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rangevalue',
    type: 'esriFieldTypeInteger',
    alias: 'rangevalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'rowvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rowvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'uniqueid',
    type: 'esriFieldTypeString',
    alias: 'uniqueid',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'gcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'gcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'bcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'bcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'alphavalue',
    type: 'esriFieldTypeDouble',
    alias: 'alphavalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];
const PRESCRIPTION_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'featureid',
    type: 'esriFieldTypeInteger',
    alias: 'featureId',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rxname',
    type: 'esriFieldTypeString',
    alias: 'rxName',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'rcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'rcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'gcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'gcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'bcolorvalue',
    type: 'esriFieldTypeInteger',
    alias: 'bcolorvalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'alphavalue',
    type: 'esriFieldTypeDouble',
    alias: 'alphavalue',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
];
const LINEFEATURE_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'Name',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
];
const BOUNDARY_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'isselected',
    type: 'esriFieldTypeInteger',
    alias: 'isselected',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: 0,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'Name',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
];
const SWATHS_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'id',
    type: 'esriFieldTypeInteger',
    alias: 'ID',
    nullable: true,
    editable: true,
    defaultValue: 0,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'Name',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'abswathlength',
    type: 'esriFieldTypeDouble',
    alias: 'Length',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
];
const ABLINE_ATTRIBUTES = [
  {
    name: 'OBJECTID',
    type: 'esriFieldTypeOID',
    alias: 'OBJECTID',
    sqlType: 'sqlTypeOther',
    nullable: false,
    editable: false,
    domain: null,
    defaultValue: null,
  },
  {
    name: 'type',
    type: 'esriFieldTypeString',
    alias: 'type',
    nullable: true,
    editable: true,
    defaultValue: null,
  },
  {
    name: 'name',
    type: 'esriFieldTypeString',
    alias: 'name',
    nullable: true,
    editable: true,
    defaultValue: '',
  },
  {
    name: 'abswathlength',
    type: 'esriFieldTypeDouble',
    alias: 'abswathlength',
    nullable: true,
    editable: true,
    domain: null,
    defaultValue: null,
  },
];

export const LAYER_CONFIG = {
  GRID: {
    id: 0,
    name: 'grid',
    attributes: GRID_ATTRIBUTES,
  },
  BLOCK: {
    id: 1,
    name: 'block',
    attributes: BLOCK_ATTRIBUTES,
  },
  GRIDLABEL: {
    id: 2,
    name: 'gridLabel',
    attributes: GRIDLABEL_ATTRIBUTES,
  },
  BLOCKLABEL: {
    id: 3,
    name: 'blockLabel',
    attributes: BLOCKLABEL_ATTRIBUTES,
  },
  REP: {
    id: 4,
    name: 'rep',
    attributes: REP_ATTRIBUTES,
  },
  BORDER: {
    id: 5,
    name: 'border',
    attributes: BORDER_ATTRIBUTES,
  },
  FILLER: {
    id: 6,
    name: 'filler',
    attributes: FILLER_ATTRIBUTES,
  },
  PRESCRIPTION: {
    id: 7,
    name: 'prescription',
    attributes: PRESCRIPTION_ATTRIBUTES,
  },
  LINEFEATURE: {
    id: 8,
    name: 'lineFeature',
    attributes: LINEFEATURE_ATTRIBUTES,
  },
  BOUNDARY: {
    id: 9,
    name: 'boundary',
    attributes: BOUNDARY_ATTRIBUTES,
  },
  SWATHS: {
    id: 10,
    name: 'swaths',
    attributes: SWATHS_ATTRIBUTES,
  },
  ABLINE: {
    id: 11,
    name: 'abLine',
    attributes: ABLINE_ATTRIBUTES,
  },
  REFERENCE: {
    id: 12,
    name: 'reference',
    attributes: GRID_ATTRIBUTES,
  },
  REFERENCELABEL: {
    id: 13,
    name: 'referenceLabel',
    attributes: GRIDLABEL_ATTRIBUTES,
  },
  DEMO: {
    id: 14,
    name: 'demo',
    attributes: GRID_ATTRIBUTES,
  },
  DEMOLABEL: {
    id: 15,
    name: 'demoLabel',
    attributes: GRIDLABEL_ATTRIBUTES,
  },
  DEMOBLOCK: {
    id: 16,
    name: 'demoBlock',
    attributes: BLOCK_ATTRIBUTES,
  },
  DEMOBLOCKLABEL: {
    id: 17,
    name: 'demoBlockLabel',
    attributes: BLOCKLABEL_ATTRIBUTES,
  },
  DEMOREP: {
    id: 18,
    name: 'demoRep',
    attributes: REP_ATTRIBUTES,
  },
  DEMOBORDER: {
    id: 19,
    name: 'demoBorder',
    attributes: BORDER_ATTRIBUTES,
  },
  DEMOFILLER: {
    id: 20,
    name: 'demoFiller',
    attributes: FILLER_ATTRIBUTES,
  },
  SKETCHVIEW: {
    id: -1,
    name: 'sketchView',
    attributes: [],
  },
  SKETCHWIDGET: {
    id: -1,
    name: 'sketchWidget',
    attributes: [],
  },
  HEATMAP: {
    id: -1,
    name: 'heatmap',
    attributes: [],
  },
};

export const GRAPHIC_TYPE = {
  GRID: 'grid',
  BLOCK: 'block',
  PLOT: 'plot',
  FILLER: 'fillerPlot',
  REPBOUNDARY: 'repBoundary',
  REPNAME: 'repName',
  PLOTNUMBER: 'plotNumber',
  GRIDLABEL: 'gridLabel',
  RXMAP: 'rxMap',
  LINEFEATURE: 'lineFeature',
  BOUNDARY: 'boundary',
  SWATHS: 'swaths',
  ABLINE: 'abLine',
  DEMO: 'demo',
  DEMOLABEL: 'demoLabel',
  DEMOBLOCK: 'demoBlock',
  DEMOPLOT: 'demoPlot',
  DEMOFILLER: 'demoFILLER',
  DEMOREPBOUNDARY: 'demoRepBoundary',
  DEMOREPNAME: 'repName',
  DEMOPLOTNUMBER: 'demoPlotNumber',
  REFERENCE: 'reference',
  REFERENCELABEL: 'referenceLabel',
  DEMOREFERENCE: 'demoReference',
  DEMOREFERENCELABEL: 'demoReferenceLabel',
};

export const SWITCHER_LAYER = {
  [LAYER_CONFIG.REFERENCE.name]: {
    id: LAYER_CONFIG.REFERENCE.name,
    displayName: 'reference Layer',
    visible: true,
  },
  [LAYER_CONFIG.GRID.name]: {
    id: LAYER_CONFIG.GRID.name,
    displayName: 'grid Layer',
    visible: true,
  },
  [LAYER_CONFIG.GRIDLABEL.name]: {
    id: LAYER_CONFIG.GRIDLABEL.name,
    displayName: 'grid Label Layer',
    visible: true,
  },
  [LAYER_CONFIG.BLOCK.name]: {
    id: LAYER_CONFIG.BLOCK.name,
    displayName: 'Block Layer',
    visible: true,
  },
  [LAYER_CONFIG.BLOCKLABEL.name]: {
    id: LAYER_CONFIG.BLOCKLABEL.name,
    displayName: 'Block Label Layer',
    visible: true,
  },
  [LAYER_CONFIG.FILLER.name]: {
    id: LAYER_CONFIG.FILLER.name,
    displayName: 'Filler Layer',
    visible: true,
  },
  [LAYER_CONFIG.REP.name]: {
    id: LAYER_CONFIG.REP.name,
    displayName: 'Rep Layer',
    visible: false,
  },
  [LAYER_CONFIG.PRESCRIPTION.name]: {
    id: LAYER_CONFIG.PRESCRIPTION.name,
    displayName: 'Prescription Layer',
    visible: true,
  },
  [LAYER_CONFIG.LINEFEATURE.name]: {
    id: LAYER_CONFIG.LINEFEATURE.name,
    displayName: 'LineFeature Layer',
    visible: true,
  },
  [LAYER_CONFIG.BOUNDARY.name]: {
    id: LAYER_CONFIG.BOUNDARY.name,
    displayName: 'Boundary Layer',
    visible: true,
  },
  [LAYER_CONFIG.SWATHS.name]: {
    id: LAYER_CONFIG.SWATHS.name,
    displayName: 'Swaths Layer',
    visible: true,
  },
  [LAYER_CONFIG.ABLINE.name]: {
    id: LAYER_CONFIG.ABLINE.name,
    displayName: 'ABLine Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMO.name]: {
    id: LAYER_CONFIG.DEMO.name,
    displayName: 'Demo Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMOLABEL.name]: {
    id: LAYER_CONFIG.DEMOLABEL.name,
    displayName: 'Demo Label Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMOBLOCK.name]: {
    id: LAYER_CONFIG.DEMOBLOCK.name,
    displayName: 'Demo Block Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMOBLOCKLABEL.name]: {
    id: LAYER_CONFIG.DEMOBLOCKLABEL.name,
    displayName: 'Demo Block Label Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMOREP.name]: {
    id: LAYER_CONFIG.DEMOREP.name,
    displayName: 'Demo Rep Layer',
    visible: false,
  },
  [LAYER_CONFIG.DEMOBORDER.name]: {
    id: LAYER_CONFIG.DEMOBORDER.name,
    displayName: 'Demo Border Layer',
    visible: true,
  },
  [LAYER_CONFIG.DEMOFILLER.name]: {
    id: LAYER_CONFIG.DEMOFILLER.name,
    displayName: 'Demo Filler Layer',
    visible: true,
  },
  [LAYER_CONFIG.HEATMAP.name]: {
    id: LAYER_CONFIG.HEATMAP.name,
    displayName: 'Heatmap Layer',
    visible: true,
  },
};

export const SAVE_OPERATION_TYPE = {
  published: 'published',
  modify: 'modify',
  trialPlacement_Save: 'trialPlacement_Save',
  gridGenerator_Save: 'gridGenerator_Save',
};

export const FILLER_OPERATION_TYPE = {
  delete: 'delete',
  add: 'add',
};

export const PLOT_COUNT_TYPE = {
  blockCount: 'blockCount',
  gridCount: 'gridCount',
};

export const APPLYEIDTS_TYPE = {
  add: 'add',
  update: 'update',
};

export const CURRENT_PAGE = {
  gridGenerator: 'gridGenerator',
  trialPlacement: 'trialPlacement',
  prescription: 'prescription',
  boundaryLine: 'boundaryLine',
};

export const MAPOPERATION_TYPE = {
  CREATE_BLOCK: 'createBlock',
  EDIT: 'edit',
  COPY: 'copy',
  DRAW_LINE_FEATURES: 'drawLineFeatures',
  DRAW_BOUNDARY: 'drawBoundary',
  DRAW_SWATH_LINES: 'drawSwathLines',
  DRAW_AB_LINES: 'drawABLines',
  EDIT_LINE_FEATURES: 'editLineFeatures',
  EDIT_BOUNDARY_FEATURES: 'editBoundaryFeatures',
  EDIT_SWATH_LINES: 'editSwathLines',
  EDIT_AB_LINES: 'editABLines',
  CREATE_PRESCRIPTION: 'creatPrescription',
  SWAP_PLOTS: 'swapPlots',
  HEAT_MAP: 'heatmap',
};

export const SHAPEFILE_UPLOAD_TYPE = {
  GRID: 'grid',
  REFERENCE: 'reference',
};

export const FIELDMAP_INFO_LIST = [
  { key: 'rotateRight', label: 'Press A to rotate map in antiClockwise direction' },
  { key: 'rotateLeft', label: 'Press D to rotate map in Clockwise direction' },
];

export const EXCLUDED_RX_ATTRIBUTES = [
  'OBJECTID',
  'objectid',
  'globalid',
  'SHAPE__Length',
  'SHAPE__Area',
];

export const FIELDMAP_TYPE = {
  DEMO: 'demo',
  RESEARCH: 'research',
};

export const LAYER_TO_HIDE = {
  RESEARCH: [
    LAYER_CONFIG.DEMO.name,
    LAYER_CONFIG.DEMOLABEL.name,
    LAYER_CONFIG.DEMOBLOCK.name,
    LAYER_CONFIG.DEMOBLOCKLABEL.name,
    LAYER_CONFIG.DEMOREP.name,
    LAYER_CONFIG.DEMOFILLER.name,
    LAYER_CONFIG.REFERENCE.name,
    LAYER_CONFIG.REP.name,
    LAYER_CONFIG.LINEFEATURE.name,
    LAYER_CONFIG.BOUNDARY.name,
    LAYER_CONFIG.SWATHS.name,
    LAYER_CONFIG.ABLINE.name,
    LAYER_CONFIG.PRESCRIPTION.name,
  ],
  DEMO: [
    LAYER_CONFIG.GRID.name,
    LAYER_CONFIG.GRIDLABEL.name,
    LAYER_CONFIG.REFERENCE.name,
    LAYER_CONFIG.REP.name,
    LAYER_CONFIG.LINEFEATURE.name,
    LAYER_CONFIG.BOUNDARY.name,
    LAYER_CONFIG.SWATHS.name,
    LAYER_CONFIG.ABLINE.name,
    LAYER_CONFIG.PRESCRIPTION.name,
    LAYER_CONFIG.BLOCK.name,
    LAYER_CONFIG.BLOCKLABEL.name,
    LAYER_CONFIG.FILLER.name,
  ],
};

export const CUSTOM_BUTTON = {
  CREATE_BLOCK: { id: 'createBlock', label: 'Create Block' },
  CLEAR_BLOCK: { id: 'clearBlock', label: 'Clear Block' },
  CLEAR_TRIALS: { id: 'clearTrials', label: 'Clear Trials' },
  SWAP_PLOTS: { id: 'swapPlots', label: 'Swap Plots' },
  VALIDATE: { id: 'validate', label: 'Validate' },
  DELETE: { id: 'delete', label: 'Delete' },
  EXIT: { id: 'exit', label: 'Exit' },
  CUT: { id: 'cut', label: 'Cut Graphics' },
  COPY: { id: 'copy', label: 'Copy Graphics' },
  SAVE: { id: 'save', label: 'Save Graphics' },
  DISCARD: { id: 'discard', label: 'Discard Changes' },
  REDRAW: { id: 'redraw', label: 'Redraw Boundary' },
};

export const CURRENT_MODE = {
  LINE_FEATURES: 'lineFeatures',
  BOUNDARY_LINES: 'boundaryLines',
  SWATHS: 'swaths',
  SWAP_PLOTS: 'swapPlots',
  HEAT_MAP: 'heatMap',
};

export const SYMBOL_TYPE = {
  highlightedSymbol: 'highlightedSymbol',
  fillerSymbol: 'fillerSymbol',
  plotSymbol: 'plotSymbol',
};

export const GRID_GENERATION_BUTTON_NAME = {
  GENERATE_GRID: 'Generate Grid',
  GENERATE_DEMO_GRID: 'Generate Demo Grid',
  GRID_APPEND: 'Grid Append',
  DEMO_GRID_APPEND: 'Demo Grid Append',
};

export const TEMP_LAYER_ID = {
  SELECTED_BOUNDARY: 'tempSelectedBoundaryLayer',
  REDRAW_BOUNDARY: 'tempRedrawBoundaryLayer',
  CUT_COPY_HIGHLIGHTED_LAYER: 'tempCutCopyHighlightedLayer',
};

export const HEATMAP_TYPE = {
  COLOR: 'color',
  TEXT: 'textValue',
};
